import { t } from 'ember-intl';
import NavTabs from 'tio-reimagined/components/nav-tabs';
import { array, hash } from '@ember/helper';
import { Header, VStack } from 'tio-ui/components/layout';

<template>
  <VStack>
    <Header>{{t "coaching.student_loan_coaches"}}</Header>
    <NavTabs
      @tabs={{array
        (hash
          label=(t "coaching.about.tab_title")
          route="authenticated.repaying-student-debt.coaching.index"
        )
        (hash
          label=(t "coaching.schedule_time.tab_title")
          route="authenticated.repaying-student-debt.coaching.schedule"
        )
      }}
    />
    {{outlet}}
  </VStack>
</template>
